(() => {
  'use strict';
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const q = selector => root.querySelector(selector);
    const qa = selector => [...root.querySelectorAll(selector)];
    const product = JSON.parse(q('[data-product-json]').textContent);
    const labels = JSON.parse(q('[data-labels]').textContent);
    const couponButton=q('[data-copy-coupon]');
    couponButton?.addEventListener('click',async()=>{
      const code=root.dataset.coupon;
      if(!code)return;
      try{
        try{await navigator.clipboard.writeText(code);}
        catch{
          const input=document.createElement('textarea');
          input.value=code;input.readOnly=true;input.style.cssText='position:fixed;opacity:0;pointer-events:none';
          document.body.append(input);input.select();
          const copied=document.execCommand('copy');input.remove();couponButton.focus({preventScroll:true});
          if(!copied)throw new Error('copy');
        }
        const original=couponButton.dataset.originalLabel||couponButton.textContent;
        couponButton.dataset.originalLabel=original;couponButton.textContent=labels.copied;
        clearTimeout(couponButton.copyTimer);
        couponButton.copyTimer=setTimeout(()=>{couponButton.textContent=original;},2200);
      }catch{couponButton.textContent=code;}
    });
    const money = amount => new Intl.NumberFormat('pt-BR', {style:'currency',currency:root.dataset.currency || 'BRL'}).format(amount / 100);
    const displayColor = value => Number(root.dataset.kit) > 1 ? String(value || '').replace(/\s*\|\s*/g, ' + ') : value;
    const form = q('form.mensch-product-form');
    const mainButton = q('.add-button');
    const initial = product.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant'));
    const configuredInitial = product.variants.find(v => String(v.id) === root.dataset.initialVariantId && v.available);
    const firstAvailable = initial || configuredInitial || product.variants.find(v => v.available) || product.variants[0];
    let color = firstAvailable.option1;
    let size = initial ? initial.option2 : '';
    const photos = qa('[data-photo-index]');
    let photo = Math.max(0, photos.findIndex(p => p.getAttribute('aria-current') === 'true'));
    const photoTrack = q('[data-photo-track]');
    const slides = qa('[data-gallery-slide]');
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const kitCarousel = q('[data-kit-carousel]');
    if (kitCarousel) {
      const controls = q('[data-kit-controls]');
      const previous = q('[data-kit-previous]');
      const next = q('[data-kit-next]');
      const syncKitControls = () => {
        const end = Math.max(0, kitCarousel.scrollWidth - kitCarousel.clientWidth);
        controls.hidden = end < 2;
        previous.disabled = kitCarousel.scrollLeft < 2;
        next.disabled = kitCarousel.scrollLeft >= end - 2;
      };
      const scrollKit = direction => {
        const card = kitCarousel.querySelector('.purchase-options__card');
        const gap = parseFloat(getComputedStyle(kitCarousel).columnGap) || 0;
        kitCarousel.scrollBy({left: direction * 2 * (card.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => scrollKit(-1));
      next.addEventListener('click', () => scrollKit(1));
      kitCarousel.addEventListener('scroll', syncKitControls, {passive:true});
      kitCarousel.addEventListener('keydown', e => {
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault();
          scrollKit(e.key === 'ArrowRight' ? 1 : -1);
        }
      });
      const kitResize = new ResizeObserver(() => {
        if (!root.isConnected) { kitResize.disconnect(); return; }
        syncKitControls();
      });
      kitResize.observe(kitCarousel);
      syncKitControls();
    }
    const sticky = q('[data-sticky]');
    const stickyButton = q('[data-sticky-buy]');
    let goneAbove = false;
    const variant = () => product.variants.find(v => v.option1 === color && v.option2 === size);
    const sizeControl = q('.size-control');
    const selectionError = q('[data-selection-error]');
    function clearSelectionError() {
      selectionError.hidden = true;
      sizeControl.classList.remove('has-selection-error');
      qa('[data-size]').forEach(button => {
        button.removeAttribute('aria-invalid');
        const ids = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== selectionError.id);
        if (ids.length) button.setAttribute('aria-describedby', ids.join(' '));
        else button.removeAttribute('aria-describedby');
      });
    }
    function requestSizeSelection() {
      selectionError.hidden = false;
      sizeControl.classList.add('has-selection-error');
      qa('[data-size]').forEach(button => {
        if (button.disabled) return;
        button.setAttribute('aria-invalid', 'true');
        const ids = new Set((button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        ids.add(selectionError.id);
        button.setAttribute('aria-describedby', [...ids].join(' '));
      });
      selectionError.focus({preventScroll:true});
      sizeControl.scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:'center'});
    }
    function syncPhoto(index) {
      if (!photos.length) return;
      photo=(index+photos.length)%photos.length;
      photos.forEach((button,i)=>button.setAttribute('aria-current',String(i===photo)));
      slides.forEach((slide,i)=>slide.setAttribute('aria-hidden',String(i!==photo)));
      q('[data-photo-count]').textContent=(photo+1)+' / '+photos.length;
      const rail=q('[data-thumbnails]'),selected=photos[photo];
      rail.scrollTo({left:Math.max(0,selected.offsetLeft-(rail.clientWidth-selected.offsetWidth)/2),top:Math.max(0,selected.offsetTop-(rail.clientHeight-selected.offsetHeight)/2),behavior:reducedMotion.matches?'instant':'smooth'});
    }
    function setPhoto(index, behavior='smooth') {
      if (!photos.length) return;
      const previous=photo;
      syncPhoto(index);
      photoTrack.scrollTo({left:photo*photoTrack.clientWidth,behavior:reducedMotion.matches || Math.abs(photo-previous)>1?'instant':behavior});
    }
    function syncSticky() {
      if(!sticky) return;
      const drawer=document.querySelector('cart-drawer');
      sticky.hidden=!goneAbove || !!q('[data-photo-dialog]').open || !!drawer?.classList.contains('active');
      sticky.classList.toggle('is-mobile',matchMedia('(max-width:760px)').matches);
      const busy=mainButton.getAttribute('aria-disabled')==='true';
      stickyButton.disabled=busy || !product.available;
      q('[data-sticky-label]').textContent=!product.available?labels.soldOut:variant()?.available?labels.add:labels.choose;
    }
    function update() {
      const chosen=variant(),display=chosen || product.variants.find(v=>v.option1===color && v.available) || product.variants.find(v=>v.option1===color) || firstAvailable;
      const idInput=form.querySelector('[name="id"]');
      idInput.value=chosen?.id || display.id;
      if(q('[data-color-label]')) q('[data-color-label]').textContent=displayColor(color);
      if(q('[data-color-select]')) q('[data-color-select]').value=color;
      qa('[data-color]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.color===color));b.disabled=!product.variants.some(v=>v.option1===b.dataset.color && v.available);});
      qa('[data-color-select] option').forEach(o=>o.disabled=!product.variants.some(v=>v.option1===o.value && v.available));
      qa('[data-size]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.size===size));b.disabled=!product.variants.some(v=>v.option1===color && v.option2===b.dataset.size && v.available);});
      q('[data-price]').textContent=money(display.price);
      if(q('[data-kit-piece-price]')) q('[data-kit-piece-price]').textContent=money(Math.round(display.price/Number(root.dataset.kit)));
      const compare=q('[data-compare]'),saving=q('[data-saving]');
      compare.hidden=saving.hidden=!(display.compare_at_price>display.price);
      compare.textContent=money(display.compare_at_price || 0);
      saving.textContent=Number(root.dataset.kit)>1?labels.save.replace('__amount__',money(display.compare_at_price-display.price)):Math.round((display.compare_at_price-display.price)/display.compare_at_price*100)+'% OFF';
      const installments=Number(root.dataset.installments),pix=Number(root.dataset.pix);
      const installment=money(Math.ceil(display.price/installments));
      q('[data-payment]').innerHTML=labels.installment.replace('__count__',installments).replace('__amount__',installment)+'<br>'+labels.pix.replace('__amount__',money(Math.round(display.price*(100-pix)/100))).replace('__percent__',pix);
      mainButton.disabled=!product.available || (!!chosen && !chosen.available);
      mainButton.querySelector('span').textContent=mainButton.disabled?labels.soldOut:labels.add;
      if(sticky){q('[data-sticky-price]').textContent=money(display.price);q('[data-sticky-installment]').textContent=installments+'x '+installment+' sem juros';q('[data-sticky-selection]').textContent=[displayColor(color),size].filter(Boolean).join(' · ');if(Number(root.dataset.kit)===1 && display.featured_image?.src)q('.sticky-photo').src=display.featured_image.src;}
      if(chosen){const url=new URL(location.href);url.searchParams.set('variant',chosen.id);history.replaceState(history.state,'',url);}
      if (chosen?.available) clearSelectionError();
      syncSticky();
    }
    function changeColor(next) {
      color=next;
      if(size && !variant()?.available)size='';
      update();
      if(Number(root.dataset.kit)===1){const v=variant() || product.variants.find(v=>v.option1===color);const found=photos.findIndex(p=>String(v?.featured_image?.id)===p.dataset.imageId);if(found>=0)setPhoto(found);}
    }
    qa('[data-color]').forEach(b=>b.addEventListener('click',()=>changeColor(b.dataset.color)));
    q('[data-color-select]')?.addEventListener('change',e=>changeColor(e.target.value));
    qa('[data-size]').forEach(b=>b.addEventListener('click',()=>{size=b.dataset.size;update();}));
    form.addEventListener('submit',e=>{
      if(!size || !variant()?.available){e.preventDefault();e.stopImmediatePropagation();requestSizeSelection();}
    },true);
    stickyButton?.addEventListener('click',()=>form.requestSubmit(mainButton));
    const buttonObserver=new MutationObserver(syncSticky);
    buttonObserver.observe(mainButton,{attributes:true,attributeFilter:['aria-disabled','disabled']});
    const drawer=document.querySelector('cart-drawer');
    if(drawer)buttonObserver.observe(drawer,{attributes:true,attributeFilter:['class']});
    if(sticky){new IntersectionObserver(entries=>{goneAbove=entries[0].boundingClientRect.bottom<0;syncSticky();},{threshold:0}).observe(mainButton);window.addEventListener('resize',syncSticky,{passive:true});}
    photos.forEach((p,i)=>p.addEventListener('click',()=>setPhoto(i)));
    qa('[data-photo-step]').forEach(b=>b.addEventListener('click',()=>setPhoto(photo+Number(b.dataset.photoStep))));
    const dialog=q('[data-photo-dialog]');
    const zoom=()=>{q('[data-large-photo]').src=photos[photo].dataset.image;dialog.showModal();syncSticky();};
    // Native horizontal scrolling follows the finger; CSS snap settles each photo.
    let gesture, dragged=false, scrollFrame;
    photoTrack.addEventListener('pointerdown',e=>{gesture={x:e.clientX,y:e.clientY};dragged=false;},{passive:true});
    photoTrack.addEventListener('pointermove',e=>{if(gesture && (Math.abs(e.clientX-gesture.x)>8 || Math.abs(e.clientY-gesture.y)>8))dragged=true;},{passive:true});
    photoTrack.addEventListener('pointercancel',()=>{dragged=true;gesture=null;},{passive:true});
    photoTrack.addEventListener('pointerup',()=>{gesture=null;},{passive:true});
    photoTrack.addEventListener('click',e=>{if(dragged){e.preventDefault();return;}zoom();});
    photoTrack.addEventListener('scroll',()=>{
      if(scrollFrame)return;
      scrollFrame=requestAnimationFrame(()=>{
        scrollFrame=null;
        if(!photoTrack.clientWidth)return;
        const nearest=Math.max(0,Math.min(photos.length-1,Math.round(photoTrack.scrollLeft/photoTrack.clientWidth)));
        if(nearest!==photo)syncPhoto(nearest);
      });
    },{passive:true});
    photoTrack.addEventListener('keydown',e=>{
      if(e.altKey || e.ctrlKey || e.metaKey)return;
      if(e.key==='ArrowLeft' || e.key==='ArrowRight'){e.preventDefault();setPhoto(photo+(e.key==='ArrowRight'?1:-1));}
    });
    const galleryResize=new ResizeObserver(()=>{
      if(!root.isConnected){galleryResize.disconnect();return;}
      photoTrack.scrollTo({left:photo*photoTrack.clientWidth,behavior:'instant'});
    });
    photoTrack.classList.add('is-ready');
    setPhoto(photo,'instant');
    galleryResize.observe(photoTrack);
    q('[data-photo-zoom]').addEventListener('click',zoom);
    dialog.querySelector('.close-dialog').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});dialog.addEventListener('close',syncSticky);
    const related=q('[data-mensch-related]');
    if(related){const observer=new IntersectionObserver(async entries=>{if(!entries.some(e=>e.isIntersecting))return;observer.disconnect();try{const response=await fetch(related.dataset.url);if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html'),content=doc.querySelector('[data-related-content]');if(content){related.append(content);related.querySelectorAll('[data-rail]').forEach(b=>b.addEventListener('click',()=>{const rail=related.querySelector('[data-related-rail]');rail.scrollBy({left:Number(b.dataset.rail)*rail.clientWidth*.8,behavior:'smooth'});}));}}catch{}},{rootMargin:'600px'});observer.observe(related);}
    update();
  };
  document.querySelectorAll('[data-mensch-pdp]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-mensch-pdp]').forEach(init));
})();



